module.exports = __webpack_public_path__ + "a83fca6504f68e9ab1755b69bcaf5316.jpg";